import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { TopMatterWithDetails } from 'reservations/account/components/TopMatterWithDetails';
import { MaxPartySizeText } from 'reservations/availabilities/components/MaxPartySizeText';
import PartySize from 'reservations/availabilities/components/PartySize';
import { useIsBeyondMaxPartySize } from 'reservations/availabilities/hooks/useIsBeyondMaxPartySize';
import { LayoutWithGutter } from 'reservations/base/components/LayoutWithGutter';
import { useRouteIfAppDisabled } from 'reservations/base/hooks/useRouteIfAppDisabled';
import {
  FORM_DRAWER,
  useModal
} from 'reservations/base/providers/ModalProvider';
import { WAITPARTY } from 'reservations/booking/types';
import BackgroundOverlayImageWrapper from 'reservations/brand/components/BackgroundOverlayImageWrapper';
import { DinerFieldsDrawer } from 'reservations/form/components/DinerFieldsDrawer';
import Form from 'reservations/form/components/Form';
import {
  SUBMISSION_TYPES,
  useBookingForm
} from 'reservations/form/providers/BookingFormProvider';
import JoinWaitlistButton from 'reservations/waitlist/components/JoinWaitlistButton';
import WaitlistProvider from 'reservations/waitlist/providers/WaitlistProvider';

type Props = {
  slug: string;
};

function WaitlistOnlyGrid() {
  useRouteIfAppDisabled();
  const {
    handleModalClose,
    handleModalOpen: handleFormDrawerOpen,
    isModalOpen: isFormDrawerOpen
  } = useModal(FORM_DRAWER);
  const { setValue } = useFormContext();

  const { setSubmissionType } = useBookingForm();
  useEffect(() => {
    setSubmissionType(SUBMISSION_TYPES.WAITLIST_FORM);
    setValue('bookingType', WAITPARTY);
  }, []);

  const handleWaitlistClick = () => {
    handleFormDrawerOpen();
  };

  const isBeyondMaxPartySize = useIsBeyondMaxPartySize();

  return (
    <Grid container direction="column" spacing="36px" sx={{ px: '16px' }}>
      <Grid item>
        <Box sx={{ px: '16px' }}>
          <PartySize />
        </Box>
      </Grid>
      <Grid item>
        {isBeyondMaxPartySize ? (
          <MaxPartySizeText />
        ) : (
          <JoinWaitlistButton
            sxProps={{ maxWidth: '95%' }}
            showNumberOfPartiesAhead
            onClick={handleWaitlistClick}
          />
        )}
      </Grid>
      <DinerFieldsDrawer
        open={isFormDrawerOpen}
        handleFormDrawerClose={handleModalClose}
      />
    </Grid>
  );
}

const WaitlistOnlyScreen = ({ slug }: Props) => (
  <>
    <Box sx={{ pt: '130px' }}>
      <TopMatterWithDetails />
    </Box>
    <Form>
      <BackgroundOverlayImageWrapper additionalHeight={400}>
        <WaitlistProvider slug={slug}>
          <LayoutWithGutter>
            <WaitlistOnlyGrid />
          </LayoutWithGutter>
        </WaitlistProvider>
      </BackgroundOverlayImageWrapper>
    </Form>
  </>
);

export default WaitlistOnlyScreen;
